class Constants {
    static ChargePointCommand = {
        StopTransaction: 'StopTransaction',
        StopBilling: 'StopBilling',
        UnlockConnector: 'UnlockConnector',
        ChangeConfiguration: 'ChangeConfiguration',
        GetConfiguration: 'GetConfiguration',
        HardReset: 'HardReset',
        SoftReset: 'SoftReset',
        PushServerData: 'PushServerData'
    }
}

export default Object.freeze(Constants);